
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControlLabel,
  Grid2,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import AddIcon from "@mui/icons-material/Add";
import Colors from "../../assets/styles";
import { useForm } from "react-hook-form";
import AuthServices from "../../apis/AuthServices";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import { Navigate, useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';

export default function LocomotiveForm() {
  const theme = useTheme();
  const [direction, setDirection] = useState("");
  const [checkbox, setCheckBox] = useState(false);
  const [trains, setTrains] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      imei: "",
      number: "",
    },
  });
  const handleDirectionChange = (event) => {
    console.log(event.target.value)

    setDirection(event.target.value);
    setError(""); // Clear the error on valid selection
  };
  const handleCheckboxChange = (event) => {
    setCheckBox(event.target.checked);
  };


  const onSubmit = async (formData) => {
    
    const obj = {
        IsLive:  checkbox,
        IsUp: direction == "true" ? true :false,
        trainDescription: formData?.trainDesc,
        trainName : formData?.trainName,
        TrainNameUR :  formData?.trainNameUr,
        trainNumber :formData?.trainNumber,
      
    };
    setTrains([...trains,obj]);
    reset()
    setCheckBox(false)
    setDirection("")
    
  };
  const handleDelete = (index) => {
    setTrains((prevTrains) => prevTrains.filter((_, i) => i !== index));
  };

  const handleSave = async() => {
    try {
        const result = await AuthServices.addTrain(trains);
        if (result.IsSuccess == true) {
          
         
          SuccessToaster("Train Added Successfully");
           navigate("/train-list")

        }else{
          ErrorToaster("Something went Wrong")
        }
      } catch (error) {
        ErrorToaster("Something went Wrong");
      }
  };

  return (
    <Box sx={{ py: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            
            borderColor: "divider",
            mb: 1,
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{
              color: Colors.primary,
              fontWeight: 500,
              letterSpacing: "1px",
            }}
          >
            ADD TRAIN
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            TRAIN / ADD TRAIN
          </Typography>
        </Box>

      <Card sx={{ mb: 4 ,borderRadius:"12px"}}>
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            color: Colors.primary,
            
            borderColor: "divider",
          }}
        >
          <Typography variant="h6">TRAIN DETAILS</Typography>
        </Box>
        <CardContent>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid2 container spacing={2} sx={{ mb: 3 }}>
        {/* Name Field */}
        <Grid2  size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Name
          </Typography>
          <TextField
            fullWidth
            {...register("trainName", {
              required: "Train Name is Required",
            })}
            error={!!errors.trainName}
            helperText={errors.trainName ? errors.trainName.message : ""}
          />
        </Grid2>

        {/* Train Number Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Number
          </Typography>
          <TextField
            fullWidth
            {...register("trainNumber", { required: "Train Number is Required" })}
            error={!!errors.trainNumber}
            helperText={errors.trainNumber ? errors.trainNumber.message : ""}
          />
        </Grid2>

        {/* Train Name (Urdu) Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Name (Urdu)
          </Typography>
          <TextField
            fullWidth
            {...register("trainNameUr", {
              required: "Train Name (Urdu) is Required",
            })}
            error={!!errors.trainNameUr}
            helperText={errors.trainNameUr ? errors.trainNameUr.message : ""}
          />
        </Grid2>

        {/* Train Description Field */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Description
          </Typography>
          <TextField
            fullWidth
            {...register("trainDesc", {
              required: "Train Description is Required",
            })}
            error={!!errors.trainDesc}
            helperText={errors.trainDesc ? errors.trainDesc.message : ""}
          />
        </Grid2>
        <Grid2 size={{xs:12 ,md:4}}>
  <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
    Direction
  </Typography>
  <RadioGroup
        row
        value={direction}
        onChange={handleDirectionChange}
      >
        <FormControlLabel value="true" control={<Radio />} label="Up" />
        <FormControlLabel value="false" control={<Radio />} label="Down" />
      </RadioGroup>

  {/* {errors.direction && (
    <Typography color="error" variant="caption">
      {errors.direction.message}
    </Typography>
  )} */}
</Grid2>

        {/* IsLive Checkbox */}
        <Grid2 size={{xs:12 ,md:4}}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Is Live
          </Typography>
          <FormControlLabel
          control={
            <Checkbox
              checked={checkbox} // State controls the checked value
              onChange={handleCheckboxChange} // Update state on change
            />
          }
          label="is Live"
        />
        </Grid2>
        <Grid2
                size={{ xs: 12, md: 12 }}
                sx={{ display: "flex", alignItems: "flex-end" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    bgcolor: "#133e02",
                    "&:hover": {
                      bgcolor: "green.800",
                    },
                  }}
                >
                  <AddIcon />
                </Button>
              </Grid2>
      </Grid2>

      {/* Submit Button */}
     
    </Box>
        </CardContent>
      </Card>

      <Card  sx={{borderRadius:"12px"}}> 
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: 1,
            borderColor: "divider",
            color: Colors.primary,
          }}
        >
          <Typography variant="h6">ADDED TRAIN LIST</Typography>
        </Box>
        <CardContent>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#133e02" }}>
                  <TableCell sx={{ color: "white" }}>#</TableCell>
                  <TableCell sx={{ color: "white" }}>Train Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Train Name (Urdu)</TableCell>
                  <TableCell sx={{ color: "white" }}>Train Number</TableCell>
                  <TableCell sx={{ color: "white" }}>UP/DN</TableCell>
                  <TableCell sx={{ color: "white" }}>Train Description</TableCell>
                  <TableCell sx={{ color: "white" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {trains.map((loco, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{loco.trainName}</TableCell>
                    <TableCell>{loco.TrainNameUR}</TableCell>
                    <TableCell>{loco.trainNumber}</TableCell>
                   
                    <TableCell>{loco.IsUp == true ? "UP" : "DN"}</TableCell>
                    <TableCell>{loco.trainDescription}</TableCell>
                    <TableCell><DeleteIcon onClick={()=>handleDelete(index)} sx={{cursor:"pointer"}} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {trains.length > 0 && (
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: "rgb(19 62 2)",
                "&:hover": {
                  bgcolor: "rgb(19 62 2)",
                },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
